import { RadioFilterType } from './types'
import { ParamsUpdater } from '../List/hooks'
import React, { useCallback } from 'react'

type RadioFilterProps<T> = {
  readonly filter: RadioFilterType<T>
  readonly value: T[keyof T]
  readonly updateParams: ParamsUpdater<T>
}
export const RadioFilter = <T,>({
  filter,
  value,
  updateParams,
}: RadioFilterProps<T>): JSX.Element => {
  const onChange = useCallback((value) => {
    updateParams(filter.fieldName, value)
  }, [])
  return (
    <>
      {filter.options.map((o) => {
        const onSelect = useCallback(() => onChange(o.value), [o.value])
        return (
          <div key={o.name}>
            <label>
              <input
                name={o.name}
                type='radio'
                onChange={onSelect}
                checked={o.value === value}
              />
              {o.name}
            </label>
          </div>
        )
      })}
    </>
  )
}
